export const BUYER_REFUND_POLICY_HELP_URL = '/help/465'
